import type { ReactNode } from 'react';

export const symbol_arrows_left_right_circle: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M324-111.5Q251-143 197-197t-85.5-127Q80-397 80-480t31.5-156Q143-709 197-763t127-85.5Q397-880 480-880t156 31.5Q709-817 763-763t85.5 127Q880-563 880-480t-31.5 156Q817-251 763-197t-127 85.5Q563-80 480-80t-156-31.5ZM480-140q141 0 240.5-99T820-480q0-141-99.5-240.5T480-820q-142 0-241 99.5T140-480q0 142 99 241t241 99Zm0-340Zm-79 125q9-9 9-21t-9-21l-53-53h264l-53 53q-9 9-9 21t9 21q9 9 21 9t21-9l104-104q9-9 9-21t-9-21L601-605q-9-9-21-9t-21 9q-9 9-9 21t9 21l53 53H348l53-53q9-9 9-21t-9-21q-9-9-21-9t-21 9L255-501q-9 9-9 21t9 21l104 104q9 9 21 9t21-9Z"
		/>
	</svg>
);
